import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IDeviceFullInfoContext,
	DeviceFullInfoContext,
} from '../../../../../deviceFullInfoState/deviceFullInfoContext';

const TLSInfo: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	return (
		<>
			{deviceForFullInfo?.useTlsCertificate && deviceForFullInfo?.tlsCertificateFilePath && (
				<FullInfoField label="certificate.p12" />
			)}
		</>
	);
};

export default TLSInfo;
